// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  googleMaps: {
    // Key del ambiente (restringida por referrer en Google Cloud Console)
    apiKey: 'AIzaSyAtmjFGPQiQsFSAozEXr1jZ5W9cmgjp4FY',
    // Map IDs de Google Cloud Console (Map Management), con el estilo claro/oscuro asociado
    mapIds: {
      light: 'd9ddb0de1791b060f195f441',
      dark: 'd9ddb0de1791b060e0a62830',
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
